import { Instance, types } from 'mobx-state-tree'

import { JsonMap, UserTraits } from '@segment/analytics-react-native'

import { EnvironmentStages } from '../environment/environment.store'
import { withRootStore } from '../extensions'
import { getSegmentClient, isSegmentInitialized } from './segment'
import { toAnalyticsIdentity } from './analytics-identity'
import { firebaseAnalytics } from '@/modules/firebase'
import { DdLogs } from '@/modules/datadog'
import { Platform } from 'react-native'
/**
 * A SessionEventAnalyticsModel model.
 */

// New default: don't actually send in simulator, emulator, dev builds
// If needed override with 'true' here (while testing new events)
const turnOn = !__DEV__

export const EventAnalyticsStore = types
  .model('EventAnalyticsStore')
  .props({
    event: types.maybe(types.string)
  })
  .extend(withRootStore)
  .actions((self) => ({
    //props type -> JsonMap
    setEvent(event: string, props?: JsonMap) {
      const user = self.rootStore.session.user
      let eventProps = props
      if (props && user?.auth0Id) {
        // Only translate the current account's ID; another user's ID may be event data.
        eventProps = {
          ...props,
          ...(props.userId === user._id && { userId: user.auth0Id }),
          ...(props.user_id === user._id && { user_id: user.auth0Id })
        }
      }
      // Startup-ordering diagnostic: events sent before bootstrapApp() started Segment.
      if (!isSegmentInitialized()) {
        const line = `[segment] setEvent before initSegment(): ${event}`
        console.warn(line)
        void DdLogs.warn(line)
      }
      turnOn && getSegmentClient()?.track(event, eventProps)
    },
    getUserIdentify() {
      const anonymousId = getSegmentClient()?.userInfo?.get().anonymousId
      return anonymousId
    },
    getSegmentUserID() {
      const segmentUserID = getSegmentClient()?.userInfo?.get().userId
      return segmentUserID
    },
    isSkillLevelAvailableInTraits() {
      const traits = getSegmentClient()?.userInfo?.get().traits
      if (traits?.skill_level) {
        return true
      }
      return false
    },
    //props type -> UserTraits
    setUserIdentify(userid: string, props?: UserTraits) {
      const sessionUser = self.rootStore.session.user
      if (sessionUser && userid === sessionUser._id) {
        const identity = toAnalyticsIdentity(sessionUser)
        userid = identity.userId
        props = { ...props, ...identity.traits }
      }
      turnOn && getSegmentClient()?.identify(userid, props)
      //TODO: not working on web
      if (Platform.OS !== 'web') {
        firebaseAnalytics().setUserId(userid)
      }
    }
  }))
  .actions((self) => ({
    async setAlias(userId: string) {
      turnOn && (await getSegmentClient()?.alias(userId))

      //TODO: not working on web
      if (Platform.OS !== 'web') {
        await firebaseAnalytics().setUserId(userId)
        await firebaseAnalytics().setUserProperties({ userId })
      }
    },
    async setAnalyticsStage(stage: EnvironmentStages) {
      // try {
      //   if (stage === EnvironmentStages.prod) {
      //     segmentClient = createClient({
      //       writeKey: EnvironmentStages.prod,
      //       autoAddSegmentDestination: true,
      //       trackAppLifecycleEvents: true,
      //       trackDeepLinks: true,
      //     })
      //   } else {
      //     segmentClient = createClient({
      //       writeKey: EnvironmentStages.dev,
      //       autoAddSegmentDestination: true,
      //       trackAppLifecycleEvents: true,
      //       trackDeepLinks: true,
      //     })
      //   }
      //   segmentClient.add({ plugin: new MixpanelPlugin() })
      // } catch (error) {
      //   console.warn('session-analytics setAnalyticsStage', error)
      // }
    }
  }))

export type EventAnalyticsStoreType = Instance<typeof EventAnalyticsStore>
